// Select a translation key; never display backend text or internal error messages.
// An axios timeout (no response) leaves the outcome open: the page only says the login could not be confirmed.
export const isLoginTimeout = (error) => !error?.response && (error?.code === "ECONNABORTED" || error?.code === "ETIMEDOUT");

export function memberLoginErrorKey(error) {
  if (error?.memberSessionProblem === "staff_account") return "member.login.staff_account";
  if (error?.memberSessionProblem === "invalid_session") return "member.login.invalid_session";
  if (error?.memberGuard === "local_account") return "member.login.local_account";
  if (error?.memberGuard) return "member.login.env_blocked";
  const status = Number(error?.response?.status);
  if (status === 401) return "member.login.invalid_credentials";
  if (status === 403) return "member.login.access_unavailable";
  if (status === 429) return "member.login.too_many_attempts";
  if (status === 400 || status === 422) return "member.login.invalid_input";
  return "member.login.failed";
}
